import { I as IconButton, d as defineCustomElement$1 } from './p-21c18302.js';
const OwcIconButton = IconButton;
const defineCustomElement = defineCustomElement$1;
export { OwcIconButton, defineCustomElement };